import { createSelector } from 'reselect';
import _ from 'lodash';

import { CalendarParty } from 'types';
import bookedCalendarItemsSelector from 'selectors/bookedCalendarItemsSelector';
import walkInCalendarItemSelector from 'selectors/walkInCalendarItemSelector';

/**
 * Selector for parties to display in calendar that come from walk-ins.
 */
export default createSelector(
  bookedCalendarItemsSelector,
  walkInCalendarItemSelector,
  (bookedParties: CalendarParty[], walkInParties: CalendarParty[]): CalendarParty[] => {
    return _.concat(bookedParties, walkInParties);
  }
);
